import { useTranslator } from '@Localization';
import { Button } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  onClick: () => Promise<void>;
  disabled: boolean;
}

export const ExportButton = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { onClick, disabled } = props;
  const buttonText = disabled ? t('new.projects.details.export_data.generating_export_file') : t('new.projects.details.export_data.export');

  return (
    <Button
      className='export-button'
      disabled={disabled}
      onClick={() => {
        void onClick();
      }}
    >
      {buttonText}
    </Button>
  );
});
